import React, { useContext, useMemo } from 'react'
import { Provider } from 'jotai'
import { Sheet } from '@node-space/ui-components'
import { ContactAssignSearch } from 'pages/Contacts/ContactAssignSearch'
import { MassPayoutContactSearch } from 'pages/MassPayouts/pages/MassPayoutContactSearch'
import { ChannelPayment } from 'pages/Payments/ChannelPayments/ChannelPayment'
import { PaymentLink } from 'pages/Payments/PaymentLinks/PaymentLink'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { ActionIds } from 'types/types'
import { Convert } from '../ConvertV2/Convert'
import { FiatDeposit } from '../FiatDeposit/FiatDeposit'
import FiatSend from '../FiatSend/FiatSend'
import { WalletCreateForm } from '../Form/WalletCreateForm'
import { WalletEditForm } from '../Form/WalletEditForm'
import { Move } from '../Move/Move'
import { Send } from '../SendV2/Send'

interface WalletSheetProps {
  isSheetOpen: boolean
}

export const WalletSheet = ({ isSheetOpen }: WalletSheetProps) => {
  const [walletAction] = useContext(WalletActionContext)
  const { onBack, onClose, header, subHeader } = walletAction || {}

  const sheetContent = useMemo(() => {
    switch (walletAction?.actionId) {
      case ActionIds.MOVE:
        return <Move />
      case ActionIds.FIAT_DEPOSIT:
        return <FiatDeposit />
      case ActionIds.SEND:
        return <Send />
      case ActionIds.CONVERT:
        return <Convert />
      case ActionIds.FIAT_SEND:
        return <FiatSend />
      case ActionIds.PAYMENT_LINK:
        return <PaymentLink />
      case ActionIds.MASSPAYOUTS:
        return <MassPayoutContactSearch />
      case ActionIds.CHANNEL_PAYMENT:
        return <ChannelPayment />
      case ActionIds.CONTACT_ASSIGN:
        return <ContactAssignSearch />
      case ActionIds.WALLET_EDIT:
        return <WalletEditForm />
      case ActionIds.WALLET_CREATE:
        return <WalletCreateForm />
      default:
        return null
    }
  }, [walletAction])

  const handleSheetClose = () => {
    onClose?.()
  }

  return (
    <Sheet
      header={header}
      onBack={onBack}
      isOpen={isSheetOpen}
      onClose={handleSheetClose}
      subHeader={subHeader}
    >
      <Provider>{sheetContent}</Provider>
    </Sheet>
  )
}
